/**
 * Easify & Kalles ATC Tracking Fix
 * Überwacht AJAX-Anfragen an den Warenkorb
 */
(function() {
  function trackAtc() {
    console.log("Easify ATC erkannt - Sende Event an Shopify...");
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.lib) {
        console.log("ShopifyAnalytics gefunden, sende 'Added Product' Event...");
      window.ShopifyAnalytics.lib.track("Added Product", {
        category: "Cart",
        label: "Easify Custom Option"
      });
    }
    // Trigger für das UI (optional, falls Kalles den Mini-Cart nicht öffnet)
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  }

  // 1. Fetch API überwachen (Modern)
  const originalFetch = window.fetch;
  window.fetch = function() {
    return originalFetch.apply(this, arguments).then((response) => {
      if (response.ok && arguments[0] && arguments[0].includes('/cart/add')) {
        trackAtc();
      }
      return response;
    });
  };

  // 2. XMLHttpRequest überwachen (Legacy/Apps)
  const open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function() {
    this.addEventListener('load', function() {
      if (this.responseURL.includes('/cart/add') && this.status === 200) {
        trackAtc();
      }
    });
    return open.apply(this, arguments);
  };
})();